import FolderView from './FolderView';
export default FolderView;
